import React from 'react';

function Dean() {
  return (
    <section id="dean" className="leader-section leader-section--navy">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title" style={{ color: '#fff' }}>
             Message from the Dean / Director
          </h2>
          <div className="gold-underline"></div>
        </div>
        <div className="leader-content leader-content--reverse">
          <div className="leader-message-col">
            <div className="leader-quote-icon" style={{ color: 'var(--gold)' }}>"</div>
            <blockquote style={{ color: 'rgba(255,255,255,0.95)', borderLeftColor: 'var(--gold)' }}>
              Educate. Empower. Transform. These three words define our mission at Paramananda College
              of Nursing. We are dedicated to creating nurses who are not just skilled clinicians,
              but compassionate leaders in healthcare.
            </blockquote>
            <p style={{ color: 'rgba(255,255,255,0.88)' }}>
              Our curriculum is designed to meet international standards while staying rooted in the
              values of our community. Through innovative teaching methods, advanced labs, and strong
              hospital partnerships, we prepare our students for the dynamic challenges of modern healthcare.
            </p>
            <p style={{ color: 'rgba(255,255,255,0.88)' }}>
              Every student at PCN receives personalized mentorship and guidance to help them reach
              their full potential. We are proud of our graduates who are serving across India and
              around the world, making a meaningful difference every day.
            </p>
            <div className="leader-btns">
              <button className="btn btn-gold-outline">Read Full Message</button>
            </div>
          </div>
          <div className="leader-image-col">
            <div className="leader-photo-frame leader-photo-frame--gold">
              <img src="/dean.jpg" alt="Dean Mrs. Mangala V" className="leader-photo" />
            </div>
            <div className="leader-id-card leader-id-card--dark">
              <h3>Mrs. Mangala V</h3>
              <p className="leader-title-tag">Dean / Director</p>
              <p className="leader-college-tag">Paramananda College of Nursing</p>
              <p className="leader-location-tag">📍 Bengaluru, Karnataka</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Dean;
